import React from 'react';
import './Slider.css'

const Slider = () => {
    return (
        <div className="slider_area">
            <div className="container">
                <div className="slider_area_text">
                    <h2>Quality care</h2>
                    <h3>to life for the whole family</h3>
                    <p>Professional care for your health</p>
                    <a href='/' className="btn_custom">Get In Touch</a>
                </div>
            </div>
        </div>
    );
};

export default Slider;